import clsx from 'clsx';
import React from 'react';
import classes from './Table.module.scss';

export default function Table({
  children,
  className,
}: React.DetailedHTMLProps<
  React.TableHTMLAttributes<HTMLTableElement>,
  HTMLTableElement
>): React.ReactElement {
  return (
    <div className={classes.horizontalScroll}>
      <table className={clsx(classes.root, className)}>{children}</table>
    </div>
  );
}
